import { useEffect, useState } from "react";
import { Button, ButtonGroup, Input, Label, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { toast } from "react-toastify";
import { Edit, Trash } from "react-feather";

import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";
import { SelectSearch } from "components/SelectSearch";
import { priceListSuggestion } from "services/apiSupply";
import { brandsSuggestion, suggestionNomenclatrue2, updateCustomer } from "services/api";
import { AutocompleteArticle } from "features/Dashboard/AutocompleteArticle";
import { Cut } from "components/Cut";
import { TableButton } from "components/TableButton";

import "./priceExclusion.scss";

export const PriceExclusion = ({ values }) => {
  const [addRuleShown, setAddRuleShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [priceList, setPriceList] = useState(null);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [article, setArticle] = useState("");
  const [articles, setArticles] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [priceExclusion, setPriceExclusion] = useState([]);

  const openModalAdd = () => {
    setAddRuleShown(true);
    setIsEdit(false);
    setPriceList(null);
    setBrands([]);
    setBrand(null);
    setArticles([]);
    setArticle("");
    setKeywords([]);
    setKeyword("");
  }

  const brandHandler = (val) => {
    setBrand(val);
    if (brands.find(v => v.value === val.value)) {
      toast.error("Такой бренд уже добавлен");
      return;
    }
    setBrands(prev => [
      ...prev,
      val
    ]);
    setBrand(null);
  }

  useEffect(() => {
    setPriceExclusion(values.priceExclusion);
  }, [values]);

  const addRuleHandler = () => {

    if (priceExclusion.find(v => v.id === priceList.value)) {
      toast.error("Правило с таким прайс-листом существует");
      return;
    }

    setLoading(true);
    updateCustomer({
      id: values.id,
      priceExclusion: [
        ...priceExclusion,
        {
          id: priceList.value,
          name: priceList.label,
          brand: brands.map(v => ({ id: v.value, name: v.label })),
          nomenclature: articles,
          keyword: keywords
        }
      ]
    })
      .then((res) => {
        setPriceExclusion(res.priceExclusion);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  const updateRuleHandler = () => {
    setLoading(true);

    const newPriceExclusion = [...priceExclusion];

    console.log('newPriceExclusion', newPriceExclusion);

    const index = newPriceExclusion.findIndex(v => v.id === priceList.value);

    console.log('index', index);

    newPriceExclusion[index] = {
      id: priceList.value,
      name: priceList.label,
      brand: brands.map(v => ({ id: v.value, name: v.label })),
      nomenclature: articles,
      keyword: keywords
    };

    console.log('newPriceExclusion2', newPriceExclusion);

    updateCustomer({
      id: values.id,
      priceExclusion: newPriceExclusion
    })
      .then((res) => {
        setPriceExclusion(res.priceExclusion);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  const openModalEdit = (id) => {
    setAddRuleShown(true);
    setIsEdit(true);
    const priceExclusionOne = priceExclusion.filter(v => v.id === id)[0];
    setPriceList({ label: priceExclusionOne.name, value: priceExclusionOne.id });
    setBrands(priceExclusionOne.brand.map(v => ({ label: v.name, value: v.id })));
    setArticles(priceExclusionOne.nomenclature);
    setKeywords(priceExclusionOne.keyword);
  }

  const removePriceExclusionHandler = (id) => {
    setLoading(true);

    const newPriceExclusion = [...priceExclusion];

    updateCustomer({
      id: values.id,
      priceExclusion: newPriceExclusion.filter(v => v.id !== id)
    })
      .then((res) => {
        setPriceExclusion(res.priceExclusion);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (!article || !brand) {
      return;
    }

    if (articles.find(v => v.article === article && v.brand === brand)) {
      toast.error("Такой артикул уже добавлен");
      return;
    }

    setArticles(prev => [
      ...prev,
      { article, brand }
    ]);

    setArticle("");
    setBrand("");
  }, [article, brand]);

  const keywordHandler = () => {
    if (keywords.find(v => v === keyword)) {
      toast.error("Такое слово уже добавлено");
      return;
    }
    setKeywords(prev => [
      ...prev,
      keyword
    ]);

    setKeyword("");
  };

  return <div className="priceExclusion">
    {loading && <MySpinner overlay />}
    <div className="react-bootstrap-table p-0">
      <Table className="table table-hover">
        <thead>
          <tr>
            <th style={{ width: "10%" }}>Прайс лист</th>
            <th style={{ width: "30%" }}>Бренды</th>
            <th style={{ width: "30%" }}>Артикулы</th>
            <th style={{ width: "30%" }}>Ключевые слова</th>
            <th style={{ width: "8%" }}></th>
            <th style={{ width: "8%" }}></th>
          </tr>
        </thead>
        <tbody>
          {priceExclusion.map(item =>
            <tr key={item.id}>
              <td><Cut>{item.name}</Cut></td>
              <td>
                <Cut>{item.brand.map(brand => `${brand.name} `)}</Cut>
              </td>
              <td>
                <Cut>{item.nomenclature.map(n => `${n.article} ${n.brand} `)}</Cut>
              </td>
              <td>
                <Cut>{item.keyword.map(k => `${k} `)}</Cut>
              </td>
              <td>
                <TableButton
                  Icon={Edit}
                  onClick={() => openModalEdit(item.id)}
                />
              </td>
              <td>
                <TableButton
                  Icon={Trash}
                  onClick={() => removePriceExclusionHandler(item.id)}
                />
              </td>
            </tr>)}
        </tbody>
      </Table>
    </div>
    <Modal
      isOpen={addRuleShown}
      toggle={() => setAddRuleShown(false)}
      className="exclusion-modal"
    >
      {loading && <MySpinner overlay />}
      <div className="ruleBlock">
        <ModalHeader>
          <div className="modal-title-text">
            {isEdit ?
              `Редактирование исключения `
              : 'Новое правило исключения'
            }
          </div>
          <CloseButton onClick={() => setAddRuleShown(false)} />
        </ModalHeader>
        <ModalBody className=" m-3">

          <Label>Прайс лист</Label>
          <SelectSearch
            name="priceList"
            placeholder="Выберите прайс лист"
            functionSuggestion={priceListSuggestion}
            value={priceList}
            setValue={setPriceList}
            isDisabled={isEdit}
          />
          <div className="mt-2">
            <Label>Исключить бренды</Label>

            <div className="react-bootstrap-table p-0 brands">
              <Table className="table table-hover">
                <tbody>
                  {brands.map((brand, i) =>
                    <tr key={brand.value}>
                      <td>
                        {brand.label}
                      </td>
                      <td>
                        <TableButton
                          Icon={Trash}
                          onClick={() => {
                            const newBrands = [...brands];
                            newBrands.splice(i, 1);
                            setBrands(newBrands);
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <SelectSearch
              name="brand"
              placeholder="Выберите бренд"
              functionSuggestion={brandsSuggestion}
              value={brand}
              setValue={brandHandler}
              isClearable
            />
          </div>
          <div className="mt-2">
            <Label>Исключить артикулы</Label>
            <div className="react-bootstrap-table p-0 articles">
              <Table className="table table-hover">
                <tbody>
                  {articles.map(({ article, brand }, i) =>
                    <tr key={`${article}_${brand}`}>
                      <td>
                        {article}
                      </td>
                      <td>
                        {brand}
                      </td>
                      <td>
                        <TableButton
                          Icon={Trash}
                          onClick={() => {
                            const newArticles = [...articles];
                            newArticles.splice(i, 1);
                            setArticles(newArticles);
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <AutocompleteArticle
              article={article}
              brand={brand}
              setArticle={setArticle}
              setBrand={({ id, name }) => setBrand(name)}
              size
              func={suggestionNomenclatrue2}
            />
          </div>
          <div className="mt-2">
            <Label>Исключить по ключевым словам в наименовании</Label>

            <div className="react-bootstrap-table p-0 articles">
              <Table className="table table-hover">
                <tbody>
                  {keywords.map((keyword, i) =>
                    <tr key={keyword}>
                      <td>
                        {keyword}
                      </td>
                      <td>
                        <TableButton
                          Icon={Trash}
                          onClick={() => {
                            const newKeywords = [...keywords];
                            newKeywords.splice(i, 1);
                            setKeywords(newKeywords);
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <ButtonGroup style={{ width: "100%" }}>
              <Input
                onChange={e => setKeyword(e.target.value)}
                value={keyword}
              />
              <Button onClick={keywordHandler} color="primary" style={{ width: "20%" }}>
                Добавить
              </Button>
            </ButtonGroup>

          </div>

          <div className="d-flex justify-content-end">
            <Button onClick={() => { isEdit ? updateRuleHandler() : addRuleHandler() }} color="primary" className="mt-2" disabled={!priceList}>
              Сохранить правило
            </Button>
          </div>
        </ModalBody>

      </div>
    </Modal >
    <Button onClick={() => openModalAdd()} color="primary" className="mt-2">
      Добавить правило
    </Button>

  </div >
}